import React, { Fragment, useState } from 'react';
import { styles } from './DimensionsContent.css';
import { DescriptionListItem } from '../descriptionList/DescriptionList';

const BASE_DIMENSIONS_URL = 'https://jbhcdn.blob.core.windows.net/public/products/dimensions/';

const DIMENSIONS_SPECS = [
  'Product Height (mm)',
  'Product Width (mm)',
  'Product Depth (mm)',
  'Product Weight (kg)',
  'Packaged Height (mm)',
  'Packaged Width (mm)',
  'Packaged Depth (mm)',
  'Packaged Weight (kg)',
  'Product Height with Stand (mm)',
  'Product Width with Stand (mm)',
  'Product Depth with Stand (mm)',
  'Product Weight with Stand (kg)',
  'Product Height without Stand (mm)',
  'Product Width without Stand (mm)',
  'Product Depth without Stand (mm)',
  'Product Weight without Stand (kg)',
];

export const dimensionsFilter = (item: DescriptionListItem) => {
  return DIMENSIONS_SPECS.includes(item.Name) && item.Values.length > 0;
};

export const splitDimensions = (details: Array<DescriptionListItem>) => {
  const dimensions = details.filter(dimensionsFilter);
  const otherDetails = details.filter(item => !dimensionsFilter(item));

  return { dimensions, otherDetails };
};

const getDimensionsCategory = (name: string) => {
  if (name.includes('with Stand')) return 'With stand';
  if (name.includes('without Stand')) return 'Without stand';
  if (name.includes('Packaged')) return 'Package';
  return name.split(' ')[0];
};

const unitRegex = /\((.*?)\)/;
const transformDimensions = (dimensions: Array<DescriptionListItem>) => {
  const result = dimensions.reduce((acc: { [category: string]: Array<{ name: string; value: string }> }, item) => {
    const unit = item.Name.match(unitRegex)?.at(1);
    const category = getDimensionsCategory(item.Name);

    acc[category] = [
      ...(acc[category] || []),
      {
        name: item.Name.split(' ')[1],
        value: item.Values[0] ? `${item.Values[0]} ${unit}` : '-',
      },
    ];
    return acc;
  }, {});

  return result;
};

interface DimensionsContentProps {
  dimensions: Array<DescriptionListItem>;
  productGroupId: string | undefined;
}

export const DimensionsContent = ({ dimensions, productGroupId }: DimensionsContentProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const transformedDimensions = transformDimensions(dimensions);
  const dimensionsImageUrl = `${BASE_DIMENSIONS_URL}${productGroupId}.svg`;

  return (
    <table className={styles.table}>
      <tbody>
        <tr style={{ display: imageLoaded ? 'table-row' : 'none' }}>
          <td colSpan={2} className={styles.dimensionImageContainer}>
            <img
              alt="Describes the product's dimensions"
              className={styles.dimensionImage}
              src={dimensionsImageUrl}
              onLoad={() => setImageLoaded(true)}
            />
          </td>
        </tr>
        {Object.entries(transformedDimensions).map(([key, specs]) => (
          <Fragment key={key}>
            <tr>
              <th colSpan={2} className={styles.sectionHeading}>
                {key}
              </th>
            </tr>
            {specs.map(spec => (
              <tr key={spec.name} className={styles.sectionRow}>
                <td className={styles.dimensionName}>{spec.name}</td>
                <td className={styles.dimensionValue}>{spec.value}</td>
              </tr>
            ))}
          </Fragment>
        ))}
      </tbody>
    </table>
  );
};
